// iOS home-screen app (black-translucent status bar, viewport-fit=cover): the page is drawn from the very top of
// the screen, but `height: 100%` stops one status bar short of the bottom, leaving a strip of the body colour
// under the tab bar. The app owns the whole screen there, so size the page to the screen itself.
//
// iOS 26+ also fades the top of a home-screen app's page into the status bar, and the fade runs ~36 pt below the
// safe-area inset (to ~98 pt on iPhone 18 Pro / iOS 27), dimming header titles. App.tsx adds
// --standalone-top-extra to the top inset to move the headers out of it.
const STANDALONE_TOP_EXTRA = 24;

export function fitStandaloneViewport() {
  if (!(navigator as Navigator & { standalone?: boolean }).standalone) return;
  document.documentElement.style.setProperty('--standalone-top-extra', `${STANDALONE_TOP_EXTRA}px`);
  const fit = () => {
    const portrait = window.matchMedia('(orientation: portrait)').matches;
    const long = Math.max(screen.width, screen.height);
    const short = Math.min(screen.width, screen.height);
    document.documentElement.style.setProperty('--app-height', `${portrait ? long : short}px`);
  };
  fit();
  window.addEventListener('resize', fit);
  window.addEventListener('orientationchange', fit);
}
